import { AxiosInstance } from "axios";
import { LoginEmailPayload } from "../types";

export async function loginEmail(api: AxiosInstance, payload: LoginEmailPayload) {
  return await api.post("api/users/v1/users/login_email/", payload);
}
